import { message } from 'antd';

// Antd 5.x 的全局 message 实例
// 配置全局 message
message.config({
  top: 100,
  duration: 3,
  maxCount: 3,
});

// 创建全局 message 实例
let messageApi = null;

// 设置 message API 实例
export const setMessageApi = (api) => {
  messageApi = api;
};

// 全局 message 方法
export const globalMessage = {
  success: (content) => {
    if (messageApi) {
      messageApi.success(content);
    } else {
      message.success(content);
    }
  },
  error: (content) => {
    if (messageApi) {
      messageApi.error(content);
    } else {
      message.error(content);
    }
  },
  info: (content) => {
    if (messageApi) {
      messageApi.info(content);
    } else {
      message.info(content);
    }
  },
  warning: (content) => {
    if (messageApi) {
      messageApi.warning(content);
    } else {
      message.warning(content);
    }
  },
};

export default globalMessage;
